"use client";

import { useSearchParams } from "next/navigation";
import { LegalHubSection } from "./legal-hub-section";

export function LegalHubQuery() {
  const searchParams = useSearchParams();
  return <LegalHubSection query={searchParams.toString()} />;
}
